import script from "./GlobalFunc.vue?vue&type=script&lang=js"
export * from "./GlobalFunc.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__